/** Regex to extract the index bundle hash from a path like ".../assets/index-BeKq9PyM.js" */
const INDEX_SCRIPT_HASH_REGEX = /index-([a-zA-Z0-9_-]+)\.js/;

/**
 * Extracts the index script hash from the root HTML.
 * The HTML contains a script tag like: <script ... src=".../assets/index-BeKq9PyM.js">
 * Returns the hash (e.g. "BeKq9PyM") or null if not found.
 */
export function parseIndexScriptHashFromHtml(html: string): string | null {
  const match = html.match(INDEX_SCRIPT_HASH_REGEX);
  return match ? match[1] : null;
}

/**
 * Gets the index script hash from the current document (the script that loaded the app).
 * Returns null in dev (e.g. when script is /src/index.tsx) or if no matching script is found.
 */
export function getCurrentIndexScriptHash(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }
  const script = Array.from(document.scripts).find(
    (s) => s.src && INDEX_SCRIPT_HASH_REGEX.test(s.src)
  );
  if (!script) {
    return null;
  }
  const match = script.src.match(INDEX_SCRIPT_HASH_REGEX);
  return match ? match[1] : null;
}
